import React, { forwardRef } from 'react';
import DatePicker from 'react-datepicker';
import { useFormikContext } from 'formik';
import { Form } from 'react-bootstrap';
import styled from 'styled-components';
import moment from 'moment';
import PropTypes from 'prop-types';

const StyledWrapper = styled.div`
  .react-datepicker-wrapper {
    .react-datepicker__input-container {
      .form-control[readonly] {
        background-color: #fff;
      }
    }
  }
`;

const DateInput = ({ value, onClick }, ref) => (
  <Form.Control
    type="text"
    value={value}
    onClick={onClick}
    ref={ref}
    readOnly
  />
);

DateInput.propTypes = {
  value: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

const WrappedDatePicker = ({ field }) => {
  const { setFieldValue } = useFormikContext();
  return (
    <StyledWrapper>
      <DatePicker
        {...field}
        selected={(field.value && new Date(field.value)) || null}
        onChange={val => {
          setFieldValue(field.name, val);
        }}
        dateFormat="dd/MM/yyyy"
        placeholderText="DD/MM/YYYY"
        minDate={moment().subtract(13, 'months').toDate()}
        customInput={forwardRef(<DateInput />)}
      />
    </StyledWrapper>
  );
};

WrappedDatePicker.propTypes = {
  field: PropTypes.object.isRequired,
};

export default WrappedDatePicker;
